class MyCBService {
  getData(){
    return $.get( "/my_cb")
  }
}

export default MyCBService